import React from 'react';
import './Features.css';
import leftWater from '../../assets/water-left.svg';
import rightWater from '../../assets/water-right.svg';
import tea from '../../assets/turkish-tea.svg';
import wine from '../../assets/wine.svg';
import appleHealthIcon from '../../assets/apple-health-icon.png';
import drinks from '../../assets/drinks.png';

export default function Features() {
    return (
        <section className='features-section' id='features'>
            <div className="container">
                
                {/* Desktop Layout */}
                <div className="features-section-inner d-none d-md-block">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="features-box-1-section">
                                <div className="features-box-1">
                                    <h2 className='features-box-1-title'>Better Understand <br /> your habits</h2>
                                    <p className='features-box-1-text'>
                                        Commito gives you a complete picture of your hydration. Tracking every beverage helps you understand your habits, find balance, and stay properly hydrated throughout the day.
                                    </p>
                                </div>
                                <div className="features-box-icons">
                                    <img src={leftWater} alt="Icon 1" />
                                    <img src={tea} alt="Icon 2" />
                                    <img src={rightWater} alt="Icon 3" />
                                    <img src={wine} alt="Icon 4" />
                                    <img src={leftWater} alt="Icon 5" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-1 col-3 d-flex justify-content-center">
                            <p className='features-vertical-text'>Hydrate</p>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="features-box-2">
                                <div className='features-box-2-inner'>
                                    <h2 className='features-box-1-title'>
                                        Start taking care of your body 
                                        <span className='features-box-1-span'>Loved by 500+ people</span>
                                    </h2>
                                    <p className='features-box-1-text'>
                                        Understand what you’re drinking, make smarter choices, and take the first step toward a healthier, more energized you.
                                    </p>
                                </div>
                                <img className='features-box-image' src={drinks} alt="Drinks" />
                            </div>
                        </div>
                        <div className="col-md-2 col-9">
                            <div className="features-box-3-section">
                                <div className="features-box-3">
                                    <h2 className='features-box-1-title'>Simple & Intuitive Interface</h2>
                                    <p className='features-box-1-text'>
                                        An easy-to-use design that helps you track your hydration effortlessly, so you can focus on building healthier habits without any hassle.
                                    </p>
                                </div>
                                <div className="features-box-3-health">
                                    <img src={appleHealthIcon} alt="Apple Health Icon" />
                                    <p className='features-box-3-text'>Syncs with Apple Health</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Layout */}
                <div className="features-section-inner d-block d-md-none">
                    {/* Top: Start taking care of your body */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="features-box-2">
                                <div className='features-box-2-inner'>
                                    <h2 className='features-box-1-title'>
                                        Start taking care of your body 
                                        <span className='features-box-1-span'>loved by 500+ people</span>
                                    </h2>
                                    <p className='features-box-1-text'>
                                        Understand what you’re drinking, make smarter choices, and take the first step toward a healthier, more energized you.
                                    </p>
                                </div>
                                <img className='features-box-image' src={drinks} alt="Drinks" />
                            </div>
                        </div>
                    </div>

                    {/* Middle: Hydrate and Simple & Intuitive Interface */}
                    <div className="row mb-4">
                        {/* Hydrate Card */}
                        <div className="col-3 mb-3">
                            <p className='features-vertical-text'>Hydrate</p>
                        </div>
                        {/* Simple & Intuitive Interface Card */}
                        <div className="col-9 mb-3">
                            <div className="features-box-3">
                                <h2 className='features-box-1-title'>Simple & Intuitive Interface</h2>
                                <p className='features-box-1-text'>
                                An easy-to-use design that helps you track your hydration effortlessly, so you can focus on building healthier habits without any hassle.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Below Middle: Apple Health and Drinks */}
                    <div className="row mb-4">
                        {/* Apple Health */}
                        <div className="col-6 mb-3">
                            <div className="features-box-3-health">
                                <img src={appleHealthIcon} alt="Apple Health Icon" />
                                <p className='features-box-3-text'>Syncs with Apple Health</p>
                            </div>
                        </div>
                        {/* Drinks - Show only 3 icons */}
                        <div className="col-6 mb-3">
                            <div className="features-box-icons">
                                <img src={leftWater} alt="Icon 1" className="drink-icon-mobile" />
                                <img src={tea} alt="Icon 2" className="drink-icon-mobile" />
                                <img src={rightWater} alt="Icon 3" className="drink-icon-mobile" />
                                {/* Hide two icons on mobile */}
                                <img src={wine} alt="Icon 4" className="d-none d-md-block" />
                                <img src={leftWater} alt="Icon 5" className="d-none d-md-block" />
                            </div>
                        </div>
                    </div>

                    {/* Bottom: Better Understand your habits */}
                    <div className="row">
                        <div className="col-12">
                            <div className="features-box-1-section">
                                <div className="features-box-1">
                                    <h2 className='features-box-1-title'>Better Understand <br /> your habits</h2>
                                    <p className='features-box-1-text'>
                                    Commito gives you a complete picture of your hydration. Tracking every beverage helps you understand your habits, find balance, and stay properly hydrated throughout the day.                                    </p>
                                </div>
                                <div className="features-box-icons">
                                    <img src={leftWater} alt="Icon 1" />
                                    <img src={tea} alt="Icon 2" />
                                    <img src={rightWater} alt="Icon 3" />
                                    <img src={wine} alt="Icon 4" />
                                    <img src={leftWater} alt="Icon 5" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}
